import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import TagsInput from 'react-tagsinput';
import { ReactSession } from 'react-client-session';
import {Helmet} from "react-helmet";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../Dashboard.css';
import classes from "./EditImage.module.css";
import styles from '../Dashboard.module.css';
import 'react-tagsinput/react-tagsinput.css'

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../../Footer/Footer";

import noThumb from "../../../images/no-thumb.jpg";

function EditImage() {
    const  { vid } = useParams();
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const [image, setImage] = useState([]);
    const [tags, setTags] = React.useState([]);
    const [nsfw, setNsfw] = useState(true);
    const [privacy, setPrivacy] = useState(true);
    const [thumb, setThumb] = useState(null);
    ReactSession.setStoreType("localStorage");

    const logged_user = ReactSession.get('logged_user');

    const handleChange = (tags) => {
        setTags(tags);

        reset({
            'tags': tags.toString()
        });
    }

    const fetchImage = async () => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/user/image.php?uid=${logged_user}&vid=${vid}`)
            .then(response => {
                setImage(response.data);
                setTags(response.data.tags);
                setThumb(response.data.thumb);
                response.data.nsfw === '0' ? setNsfw(true) : setNsfw(false);
                response.data.private === '0' ? setPrivacy(true) : setPrivacy(false);
            })
            .catch(err => {
                console.log(err);
            })
    }

    useEffect(() => {
        fetchImage();
    }, [vid]);
        

    useEffect(() => {
        reset({
            'title': image.title,
            'description': image.description,
            'tags': tags.toString(),
            'duration': image.duration
        });
    }, [image]);

    const handleNsfw = (e) => {
        if(e.target.value === '1') {
            setNsfw(false);
        } else {
            setNsfw(true);
        }
    }

    const handlePrivacy = (e) => {
        if(e.target.value === '1') {
            setPrivacy(false);
        } else {
            setPrivacy(true);
        }
    }

    const onSubmit = (e) => {
        const toast_id = toast.loading("Please wait...");

        var data = new FormData();
        data.append('uid', logged_user);
        data.append('edited-image', vid);
        data.append('title', e.title);
        data.append('description', e.description);
        data.append('duration', e.duration);
        data.append('categ', e.categ);
        data.append('tags', e.tags);
        data.append('nsfw', e.nsfw);
        data.append('priv', e.priv);

        // let formObject = Object.fromEntries(data.entries());
        // console.log(formObject);

        axios.post(`${process.env.REACT_APP_API_URL}/api/user/update_image.php`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }).then(response => {
                console.log(response.data);
                toast.update(toast_id, {render: response.data.message, autoClose: 5000, type: response.data.status, isLoading: false});
            }).catch(err => {
                console.log(err);
            })
    }

    return (
        <>
            <Helmet>
                <title>Edit Image</title>
            </Helmet>
            <div className="container_wrapper">
                <Header />
                <div className={`${styles.main} main`}>
                    <ToastContainer />
                    <Sidebar />
                    <div className={styles.main_content}>
                        <div className={styles.content_body}>
                            <div className={styles.card}>
                                <div className="card-body">
                                    <div className={classes.form_wrap}>
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div className="row">
                                                <div className="col-4">
                                                    <div className={`${classes.image_thumb} mb-3`}>
                                                        <h5 className="mb-2">Image</h5>
                                                        <img src={thumb} onError={e => {e.target.src = noThumb}} alt="thumb" />
                                                    </div>
                                                </div>
                                                <div className="col-8">
                                                        <div className="form-group">
                                                            <label>Title:</label>
                                                            <input {...register('title', {required: true})}  className="form-control" type="text" />
                                                            {errors.title && <p className={styles.error_msg}>This field cannot be empty</p>}
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Description</label>
                                                            <textarea {...register('description', {required: true})} className="form-control" rows="3"></textarea>
                                                            {errors.description && <p className={styles.error_msg}>This field cannot be empty</p>}
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Category</label>
                                                            <select {...register('categ')} className="form-control">
                                                                <optgroup label="Categories" dangerouslySetInnerHTML={{__html: `${image.cats}`}} />
                                                            </select>
                                                            {/* <Markup content={video.cats} />
                                                            {video.cats}
                                                            <p>{[video.cats]}</p> */}
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Tags</label>
                                                            <TagsInput value={tags} onChange={handleChange} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>NSFW</label>
                                                            <div className={`form-group ${classes.radio}`}>
                                                                <label className="radio d-inline-flex">
                                                                    <input {...register('nsfw')} type="radio" className="styled" value="1" checked={!nsfw} onClick={handleNsfw}  /> <span>Not safe</span>
                                                                </label>
                                                                <label className="radio d-inline-flex">
                                                                    <input {...register('nsfw')} type="radio" className="styled" value="0" checked={nsfw} onClick={handleNsfw} /> <span>Safe</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Privacy</label>
                                                            <div className={`form-group ${classes.radio}`}>
                                                                <label className="radio d-inline-flex">
                                                                    <input {...register('priv')} type="radio" className="styled" value="1" checked={!privacy} onClick={handlePrivacy} /> <span>Followers only</span>
                                                                </label>
                                                                <label className="radio d-inline-flex">
                                                                    <input {...register('priv')} type="radio" className="styled" value="0" checked={privacy} onClick={handlePrivacy} /> <span>Everybody</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <input type="hidden" {...register('edited-image')} value={image.id} />
                                                        <input type="hidden" {...register('tags')} />
                                                        <div className="form-group mb-0">
                                                            <button className="btn btn-primary" type="submit">Update Image</button>
                                                        </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <Footer />
                    </div>
                </div>
            </div>
        </>
    );
}

export default EditImage;